
import { BaseService } from "../BaseService";
import { NoseurObject } from "@ronuse/noseur";

export interface ISupportCommunity {
    title: string;
    url_location: string;
    icon_location: string;
}

export class SupportCommunityService extends BaseService {

    protected static instance: SupportCommunityService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!SupportCommunityService.instance) SupportCommunityService.instance = new SupportCommunityService();
        return SupportCommunityService.instance;
    }

    querySupportCommunities(query: NoseurObject<string | number> = { page: 1, size: 1 }): Promise<any> {
        return this.report(this.transport.get("/hera/api/v1/support/community", { cache: true, query: this.normalizeParams(query) }));
    }

}
